import { useContext } from "react";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "@/App.context";
import { API_LOADING_ERROR, API_NO_DATA_FOUND_ERROR, API_NOT_FOUND_ERROR, ERROR_STATUS_CODES } from "@/lib/errors/error-constants";



/**
 * @typedef GetAllStatistics
 * @property {GetDimensionValues} dimensions
 */

/**
 * @typedef GetAllLeftBarValues
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics} result
 */

/**
 * @typedef GetAllStatisticsReq
 * @property {'aws' | 'gcp' | 'azure' | 'allclouds' } service
 */

export const getAllDimensions = (token) => {
  /**
   * @param {GetAllStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatisticsRes>}
   */

  return async ({ service, page, recordsPerPage }, signal) => {
    const statistics = await fetch(
      `${config.apiHost}/v1/${service}/virtual-tag/list?page=${page}&recordsPerPage=${recordsPerPage}`,
      {
        method: "GET",
        signal,
        headers: {
          Authorization: token
        }
      }
    );
    if (!statistics.ok) {
      if (ERROR_STATUS_CODES.includes(statistics.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (statistics.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await statistics.json()).message);
    }
    const res = await statistics.json();
    if (res?.data?.tagsList?.length === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return res;
  };
};

/**
 * @param {GetAllStatisticsReq} req
 * @param {any[]=} deps
 */
export const useTaggingTableData = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getAllDimensions", req, ...deps],
    queryFn: ({ signal }) => getAllDimensions(appContext.idToken)(req, signal),
  });
  return query;
};
